import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { ImageUploadService } from './image-upload.service';
import { ImageUpload } from 'src/app/core/ImageUpload';
import { CurrentPetService } from 'src/app/customer/pets/current-pet.service';
import { CustomAuthService } from 'src/app/auth.service';
import {UploadService} from '../../services/upload.service';
import {Pet} from '../pets/pet';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.css']
})
export class ImageUploadComponent implements OnInit {
    previewFile: string;
    toggleFile: boolean;
    fileName: string;
    compressed: string;
    tempFiles = [] as any;
    @Input() petId: number;
    @Output() imageUploaded: EventEmitter<any> = new EventEmitter();

    constructor(private imageUploadService: ImageUploadService,
                private s3Service: UploadService,
                private currentPetService: CurrentPetService,
                private authService: CustomAuthService) {
    }

    ngOnInit() {
    }

    upload() {
        const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
        fileUpload.click();
    }

    public onChange(event): void {
        this.tempFiles = event.target.files;
        this.s3Service.saveFiles(this.tempFiles);
        // this.imageUploaded.next(this.tempFiles);
        const height = 400;
        const width = 400;
        const image_extentions = ['jpg', 'png', 'gif', 'webp', 'tiff', 'psd', 'raw', 'bmp', 'jpeg', 'svg'];
        let imgIndex = null;
        for (let i = 0; i < this.tempFiles.length; i++ ) {
            if (image_extentions.includes(this.tempFiles[i].name.split('.')[1].toLowerCase())) {
                imgIndex = i;
            }
        }
        if (imgIndex) {
            const file: File = this.tempFiles[imgIndex];
            this.fileName = file.name.split('.')[0] + '.jpg';
            console.log(file);
            const fileReader: FileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onloadend = e => {
                this.previewFile = 'data:image/jpg;base64,' + fileReader.result.toString().split(',')[1];
                const img = new Image();
                img.src = (e.target as any).result;
                img.onload = () => {
                    const elem = document.createElement('canvas');
                    elem.width = width;
                    elem.height = height;
                    const ctx = <CanvasRenderingContext2D>elem.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                    const base64 = ctx.canvas.toDataURL('image/jpeg', 0.5).toString().split(',')[1];
                    const image = new ImageUpload('.jpg', base64);
                    // this.imageUploadService.updateImage(image);
                };
            };
        }
    }
    deleteFile(i) {

    }
}
